export default {
  agreementInput:{},
  setResponseLink:{},
  };